const config = {
    appId: 'xWIqqaOPHQqJ',
    appSecret: '2a06IArpGsVH9qLH8C1U1',
    // authUrl: 'http://oauth2-center.xjj-chain-dev.192.168.11.251.nip.io:30872/auth',
    authUrl: '',
    baseUrl: window.location.protocol + '//' + window.location.host,
    // burl: burl,
    // baseUrl: burl,
    urlHref: '',
    grant_type: 'authorization_code',
    PUBK: '',
};
export default config;
